import { defineStore } from 'pinia'
import apiService from '@/services/apiService'

export const useOrderStore = defineStore('order', {
    state: () => ({
        orders: [],
        selectedOrder: null,
        loading: false,
        error: null,
    }),

    actions: {
        async submitOrder(payload) {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.post('/orders', payload)
                return response.data
            } catch (error) {
                this.error = error
                console.error('[ORDER STORE] Błąd zapisu zamówienia:', error.response?.data || error)
                throw error
            } finally {
                this.loading = false
            }
        },

        async fetchOrders() {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.get('/orders')
                this.orders = response.data
            } catch (err) {
                this.error = err
                console.error('Błąd przy pobieraniu zamówień:', err)
            } finally {
                this.loading = false
            }
        },

        async updateOrder(orderId, payload) {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.post(`/orders/${orderId}`, payload)
                const index = this.orders.findIndex(o => o.id === orderId)
                if (index !== -1) {
                    this.orders[index] = response.data.order
                }
                return response.data
            } catch (error) {
                this.error = error
                console.error('Błąd aktualizacji zamówienia:', error.response?.data || error)
                throw error
            } finally {
                this.loading = false
            }
        },

        async deleteOrder(id) {
            this.loading = true
            this.error = null
            try {
                await apiService.post(`/orders-delete/${id}`)
                this.orders = this.orders.filter(order => order.id !== id)
            } catch (err) {
                this.error = err
                console.error(`Błąd przy usuwaniu zamówienia ${id}:`, err)
                throw err
            } finally {
                this.loading = false
            }
        },

        formatDate(date) {
            return new Date(date).toLocaleString('pl-PL', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        formatType(type) {
            switch (type) {
                case 'company':
                    return 'Firma'
                case 'individual':
                    return 'Osoba prywatna'
            }
        }
    }
})